module.exports = __webpack_public_path__ + "static/media/ycmsen.f5adae5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/report/ycmsen.png
// module id = 292
// module chunks = 0